/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningError
 */
export interface SigningError {
    /**
     * 
     * @type {string}
     * @memberof SigningError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof SigningError
     */
    message: string;
}

/**
 * Check if a given object implements the SigningError interface.
 */
export function instanceOfSigningError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function SigningErrorFromJSON(json: any): SigningError {
    return SigningErrorFromJSONTyped(json, false);
}

export function SigningErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['Title'],
        'message': json['Message'],
    };
}

export function SigningErrorToJSON(value?: SigningError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Title': value.title,
        'Message': value.message,
    };
}

